import {
  Avatar,
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
//import { orange } from "@mui/material/colors";
import { FormatListNumbered, Summarize } from "@mui/icons-material";
interface SummaryProps {
  label: string;
  value: number;
  loading: string;
  color: string;
  avatarColor: string;
  totalCount: number;
}
export const TotalValues = ({
  label,
  value,
  loading,
  color,
  avatarColor,
  totalCount,
}: SummaryProps) => {
  const theme = useTheme();
  const locale = theme.direction === "rtl" ? "ar-SA" : "en-US";
  const percent =
    totalCount === 0
      ? "—"
      : value === totalCount
        ? "100%"
        : `${((value * 100) / totalCount).toLocaleString(locale, {
            maximumFractionDigits: 2,
          })}%`;
  return (
    <Card
      elevation={0}
      sx={{
        background: `linear-gradient(135deg, ${color} 0%, ${avatarColor} 100%)`,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "rgba(255,255,255,0.18)",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
      }}
    >
      <CardContent sx={{ p: 2.25, "&:last-child": { pb: 2.25 } }}>
        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography
              color="rgba(255, 255, 255, 0.92)"
              gutterBottom
              variant="h6"
              sx={{ fontWeight: 800, lineHeight: 1.2 }}
            >
              {label}
            </Typography>
            <Avatar
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                color: "white",
                height: 38,
                width: 38,
              }}
            >
              <FormatListNumbered />
            </Avatar>
          </Stack>
          {loading === "pending" ? (
            <Stack spacing={1} sx={{ mt: 1 }}>
              <Skeleton
                variant="rounded"
                animation="wave"
                height={34}
                sx={{ bgcolor: "rgba(255,255,255,0.22)" }}
              />
              <Skeleton
                variant="rounded"
                animation="wave"
                height={24}
                width="60%"
                sx={{ bgcolor: "rgba(255,255,255,0.18)" }}
              />
            </Stack>
          ) : (
            <Stack
              sx={{
                mt: 1,
                backgroundColor: "rgba(255,255,255,0.12)",
                borderRadius: 2,
                p: 1.25,
              }}
            >
              <Typography color="white" variant="h4" sx={{ fontWeight: 800 }}>
                {`${value.toLocaleString(
                  locale
                )} / ${totalCount.toLocaleString(locale)}`}
              </Typography>
              <Typography color="rgba(255,255,255,0.92)" variant="subtitle1" sx={{ fontWeight: 700 }}>
                {percent}
              </Typography>
            </Stack>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export const Summary = ({
  label,
  value,
  loading,
  color,
  avatarColor,
  totalCount,
}: SummaryProps) => (
  <Card sx={{ backgroundColor: color }}>
    <CardContent>
      <Box>
        <Stack direction="row" justifyContent="space-between">
          <Typography
            color="white"
            gutterBottom
            variant="h4"
            sx={{ fontWeight: "900" }}
          >
            {label}
          </Typography>
          <Avatar
            sx={{
              backgroundColor: avatarColor,
              height: 56,
              width: 56,
            }}
          >
            <Summarize />
          </Avatar>
        </Stack>
        {loading === "pending" ? (
          <Skeleton variant="text" />
        ) : (
          <Stack sx={{ backgroundColor: avatarColor }}>
            <Typography color="white" variant="h3">
              {`${value.toLocaleString()}`}
            </Typography>
          </Stack>
        )}
      </Box>
    </CardContent>
  </Card>
);
